import type { ReactElement } from "react";
import { IBrazilianCompanyIssuerListingSegment } from "types/graphqlTypes";

interface IBrazilianCompanyIssuerListingSegmentProps {
  listingSegment: IBrazilianCompanyIssuerListingSegment;
}

export default function BrazilianCompanyIssuerListingSegment({
  listingSegment,
}: IBrazilianCompanyIssuerListingSegmentProps): ReactElement | null {
  if (listingSegment === IBrazilianCompanyIssuerListingSegment.Tradicional) {
    return (
      <span aria-label="Segmento de Listagem: Tradicional" className="flex text-sm font-bold text-red-700 xl:text-base">
        Tradicional
      </span>
    );
  }

  if (
    listingSegment === IBrazilianCompanyIssuerListingSegment.Nivel_1 ||
    listingSegment === IBrazilianCompanyIssuerListingSegment.Nivel_2
  ) {
    const isNivel1 = listingSegment === IBrazilianCompanyIssuerListingSegment.Nivel_1;
    const ariaLabel = `Segmento de Listagem: ${isNivel1 ? "Nível 1" : "Nível 2"}`;
    return (
      <span aria-label={ariaLabel} className="flex text-sm font-bold text-amber-700 xl:text-base">
        {isNivel1 ? "Nível 1" : "Nível 2"}
      </span>
    );
  }

  if (listingSegment === IBrazilianCompanyIssuerListingSegment.NovoMercado) {
    return (
      <span
        aria-label="Segmento de Listagem: Novo Mercado"
        className="flex text-sm font-bold text-emerald-700 xl:text-base"
      >
        Novo Mercado
      </span>
    );
  }

  if (
    listingSegment === IBrazilianCompanyIssuerListingSegment.BovespaMais ||
    listingSegment === IBrazilianCompanyIssuerListingSegment.BovespaMaisNivel_2
  ) {
    const isBovespaMais = listingSegment === IBrazilianCompanyIssuerListingSegment.BovespaMais;
    const ariaLabel = `Segmento de Listagem: ${isBovespaMais ? "Bovespa Mais" : "Bovespa Mais Nível 2"}`;
    return (
      <span aria-label={ariaLabel} className="flex text-sm font-bold text-blue-700 xl:text-base">
        {isBovespaMais ? "Bovespa Mais" : "Bovespa Mais Nível 2"}
      </span>
    );
  }

  return null;
}
